(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

document.addEventListener('DOMContentLoaded', function () {

  const banner = document.querySelector('.banner-slider');
  const headerWrapper = document.querySelector('.header-wrapper');
  const header = document.querySelector('.header');
  const searchContent = document.querySelector('.search-modal__content');
  const searchModal = document.querySelector('.search-modal');

  if (!headerWrapper) return;

  function isTopPage() {
    return !!banner;
  }

  function isInsideBanner() {
    if (!banner) return false;

    const bannerBottom =
      banner.offsetTop +
      banner.offsetHeight;

    return window.scrollY < bannerBottom;
  }

  function isSearchOpen() {
    return document.querySelector('details-modal details[open]');
  }

  function isMegaMenuOpen() {
    return document.querySelector('.mega-menu[open]');
  }

  function setTransparent() {

    headerWrapper.style.setProperty(
      'background',
      'transparent',
      'important'
    );

    if (header) {
      header.style.setProperty(
        'background',
        'transparent',
        'important'
      );
    }

    if (searchContent) {
      searchContent.style.setProperty(
        'background',
        'transparent',
        'important'
      );
    }

    if (searchModal) {
      searchModal.style.setProperty(
        'background',
        'transparent',
        'important'
      );
    }
  }

  function setWhite() {

    headerWrapper.style.setProperty(
      'background',
      '#ffffff',
      'important'
    );

    if (header) {
      header.style.setProperty(
        'background',
        '#ffffff',
        'important'
      );
    }

    if (searchContent) {
      searchContent.style.setProperty(
        'background',
        '#ffffff',
        'important'
      );
    }

    if (searchModal) {
      searchModal.style.setProperty(
        'background',
        '#ffffff',
        'important'
      );
    }
  }

  function updateHeaderState() {

    // TOP以外
    if (!isTopPage()) {
      setWhite();
      return;
    }

    // 検索中
    if (isSearchOpen()) {
      setWhite();
      return;
    }

    // メガメニュー中
    if (isMegaMenuOpen()) {
      setWhite();
      return;
    }

    // TOPの通常状態
    if (isInsideBanner()) {
      setTransparent();
    } else {
      setWhite();
    }
  }

  function closeOpenedMenus() {

    document
      .querySelectorAll('details-modal details[open]')
      .forEach(el => {
        el.open = false;
      });

    document
      .querySelectorAll('.mega-menu[open]')
      .forEach(el => {
        el.open = false;
      });
  }

  updateHeaderState();

  window.addEventListener('scroll', function () {

    closeOpenedMenus();

    updateHeaderState();
  });

  window.addEventListener('resize', updateHeaderState);

  document.addEventListener('click', function () {
    setTimeout(updateHeaderState, 20);
  });

});

  } catch(e) { console.error(e); }
})();
})();
